export default "__VITE_ASSET__kqohtmZW__"